import { MyIntegerEnum } from './enum'

export const TipoControladorSenha = {
  Produto: MyIntegerEnum.create(0, 'Produto'),
  SubProduto: MyIntegerEnum.create(1, 'SubProduto'),
  Terminal: MyIntegerEnum.create(2, 'Terminal'),
  Servico: MyIntegerEnum.create(3, 'Servico'),
  Etapa: MyIntegerEnum.create(4, 'Etapa'),
}
